<div class="thankYouCont">
    <div class="header">
        <div class="sucGiffer"></div>
        <div class="sucMsg" i18n>
            Thank you!<br><br>You have successfully completed the {{oInstrument!.instrumentName!}}.
        </div>
    </div>

    <div class="bodyMsg"i18n>
        You can close this window!
    </div>
</div>